import React from "react";
import Marquee from "react-fast-marquee";
import Tooltip from "@mui/material/Tooltip";
import "./../../../../styles/App.css";
import "./../../../../styles/CardMarquee.css";

// Import new fact-checker images
import Dintentdata from "./../../../../images/factcheckers/Dintentdata.png";
import BoomLive from "./../../../../images/factcheckers/BoomLive.jpg";
import OnlyFactsHindi from "./../../../../images/factcheckers/OnlyFactsHindi.png";
// import OnlyFactsEnglish from "./../../../../images/factcheckers/OnlyFactsEnglish.png";
import Dfrac from "./../../../../images/factcheckers/Dfrac.jpg";
// import DfracHindi from "./../../../../images/factcheckers/DfracHindi.png";
import NewsChecker from "./../../../../images/factcheckers/NewsChecker.jpg";
import NewsMeter from "./../../../../images/factcheckers/NewsMeter.png";
import Factly from "./../../../../images/factcheckers/Factly.jpg";
import IndiaTodayEng from "./../../../../images/factcheckers/IndiaTodayEng.png";
import IndiaTv from "./../../../../images/factcheckers/IndiaTv.png";
// import IndiaTvHindi from "./../../../../images/factcheckers/IndiaTvHindi.png";
import TheQuint from "./../../../../images/factcheckers/TheQuint.png";
import ViswasNews from "./../../../../images/factcheckers/VishwasNews.jpg";
import AajtakEnglish from "./../../../../images/factcheckers/AajtakEnglish.png";
import factcheckindia from "./../../../../images/factcheckers/factcheckindia.png";

function FactCarousel() {
  const cards = [
    {
      src: Dintentdata,
      tooltip: "Dintentdata",
      url: "https://dintentdata.com/",
    },
    {
      src: BoomLive,
      tooltip: "Boom Live",
      url: "https://www.boomlive.in/fact-check",
    },
    {
      src: OnlyFactsHindi,
      tooltip: "Only Facts Hindi",
      url: "https://onlyfact.in/category/fact-check-based-on-politics/",
    },
    // { src: OnlyFactsEnglish, tooltip: "Only Facts English", url: "#" },
    {
      src: Dfrac,
      tooltip: "Dfrac",
      url: "https://dfrac.org/en/topic/fact-check-en-2/",
    },
    // { src: DfracHindi, tooltip: "Dfrac Hindi", url: "#" },
    {
      src: NewsChecker,
      tooltip: "News Checker",
      url: "https://newschecker.in/",
    },
    {
      src: NewsMeter,
      tooltip: "News Meter",
      url: "https://newsmeter.in/fact-check",
    },
    {
      src: Factly,
      tooltip: "Factly",
      url: "https://factly.in/category/english/",
    },
    {
      src: IndiaTodayEng,
      tooltip: "India Today (Eng)",
      url: "https://www.indiatoday.in/fact-check",
    },
    {
      src: IndiaTv,
      tooltip: "India TV",
      url: "https://www.indiatvnews.com/fact-check",
    },
    // { src: IndiaTvHindi, tooltip: "India TV Hindi", url: "#" },
    {
      src: TheQuint,
      tooltip: "The Quint",
      url: "https://www.thequint.com/news/webqoof",
    },
    {
      src: ViswasNews,
      tooltip: "Viswas News",
      url: "https://www.vishvasnews.com/",
    },
    {
      src: AajtakEnglish,
      tooltip: "Aajtak English",
      url: "https://www.aajtak.in/fact-check",
    },
    {
      src: factcheckindia,
      tooltip: "Fact Check India",
      url: "https://factcheckindia.co.in/fact-check/",
    },
  ];

  const loopingCards = [...cards, ...cards]; // Optional: duplicate for smooth looping

  return (
    <div className="fake-news-marquee-container">
      <Marquee
        gradient={true}
        gradientColor={[248, 251, 253]}
        speed={50}
        pauseOnHover={true}
        className="custom-marquee"
      >
        {loopingCards.map((card, index) => (
          <div key={index} className="marquee-card">
            <Tooltip title={card.tooltip} arrow>
              <a href={card.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={card.src}
                  alt={card.tooltip}
                  className="marquee-img"
                />
              </a>
            </Tooltip>
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export default FactCarousel;
